// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageGroup_container__29uiK","block":"ImageGroup_block__3eDFb","image":"ImageGroup_image__tTkJj","text":"ImageGroup_text__1uyud"};